import React from 'react';

import { useAppContext } from 'src/components/app-context';

import { BodySmallText, FontColor } from '@prisjakt/ui/text/variants';

import { PriceContent, CTAText } from './styles';

import type { BaseProps } from '../../types';
import { IconChevronRight } from '@prisjakt/ui/icon/chevron-right';

type Props = Pick<BaseProps, 'priceCount'>;

export const ListCardProductFooter: React.FC<Props> = props => {
  const { priceCount } = props;

  const { t } = useAppContext();

  return priceCount ? (
    <PriceContent>
      {typeof priceCount === 'number' && (
        <CTAText>
          <BodySmallText color={FontColor.PRIMARY}>
            {t('category', 'product-offer.cta', { n: priceCount })}
          </BodySmallText>
          <IconChevronRight color="maybeBlue700" />
        </CTAText>
      )}
    </PriceContent>
  ) : null;
};
